const prepareProducts = productData => {
    return (productData || []).map(product => ({
        ...product,
        firstPrice: product.price && product.price.length > 0 ? product.price[0].value : 0,
    }));
};

export default prepareProducts;